import React from 'react'
import { Col, Row, Collapse, Button } from 'antd'
import { useNavigate } from "react-router-dom";

const AboutUsView = () => {

    return (
        <>
            <div className="content">
               <Row justify="center">
                <Col xs={24}>
                    <h2 className="center-align">About us</h2>
                </Col>
                <Col xs={24} md={22}>
                    <p>The Department of Science and Innovation-National Youth Service (DSTI-NYS) programme is a component of the government's overall National 
                        Youth Service Programme (NYS), which was launched in October 2003 as a special presidential initiative to combat the high rates of youth 
                        unemployment by giving young people the chance to engage in volunteer work and skill-building opportunities. While simultaneously giving 
                        young people the chance to access opportunities for skill development, employment, and income generation, the programme supports local 
                        and national development.  
                    </p>
                    <p>To be more specific, the NYS programme aims to: give young people a way out of long-term unemployment by giving them concrete opportunities
                         that increase their likelihood of accessing the economy; instil in young people an understanding of their important role in South Africa's 
                         development, to assist them to participate; and enable young people to develop the skills, knowledge, and ability necessary for them to make 
                         the transition to healthy independent adulthood.  
                    </p>
                    <p>The DSTI-NYS programme recruits and assigns unemployed graduates to Department of Science and Innovation partner institutions, primarily in the 
                        implementation of the science engagement programme. Although the focus is mainly on unemployed graduates in the fields of science, technology, 
                        engineering, and mathematics, there are occasionally a few spots available for graduates in other fields as well. Graduates stay in the programme 
                        for a total of 12 months while being paid a monthly stipend to help them with their basic needs. The South African Agency for the Advancement 
                        of Science and Technology (SAASTA), a division of the National Research Foundation (NRF), is responsible for managing the DSTI-NYS programme. 
                        In addition to overseeing the recruitment process, SAASTA also handles the payment of monthly stipends to the participating graduates, as well as 
                        serving as the interface between host institutions and the DSTI-NYS programme. Furthermore, SAASTA act as a link between the DSTI-NYS programme 
                        and the host institutions.  
                    </p>
                    <p>It is expected of DSTI-NYS programme participants to participate in the programme's evaluation, which will take the form of exit interviews and 
                        a separate tracking process run by the Human Sciences Research Council. Their participation is helpful for the programme's improvement and for 
                        determining whether it is accomplishing its goals. 
                    </p>
                </Col>
                </Row>
            </div>
        </>
    )
}

export default AboutUsView